var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "preview" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.is_show_preview,
            expression: "is_show_preview"
          }
        ],
        staticStyle: {
          position: "fixed",
          left: "0",
          top: "0",
          width: "100vw",
          height: "100vh",
          "z-index": "2000"
        }
      },
      [
        _c("div", {
          staticClass: "preview_zoom",
          staticStyle: {
            background: "#000",
            opacity: ".8",
            position: "absolute",
            left: "0",
            top: "0",
            width: "100%",
            height: "100%"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticStyle: {
            position: "absolute",
            "max-width": "100vw",
            left: "50%",
            top: "50%",
            "z-index": "2",
            transform: "translate(-50%, -50%)"
          },
          attrs: { src: _vm.img_url, alt: "", width: "auto", height: "80%" }
        }),
        _vm._v(" "),
        _c("Icon", {
          staticStyle: {
            position: "absolute",
            right: "60px",
            top: "60px",
            "z-index": "2",
            cursor: "pointer"
          },
          attrs: { type: "md-close", size: "30", color: "#eee" },
          on: {
            click: function($event) {
              _vm.is_show_preview = false
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeb7e778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb7e778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_image.vue
// module id = null
// module chunks = 